import React from 'react';
import $ from 'jquery';
import { Set, List, fromJS, Map } from 'immutable';
// import BreadcrumbBar from '../component/breadcrumb/BreadcrumbBar';
import { Grid, Row, Col, FormGroup, HelpBlock, OverlayTrigger, Tooltip } from 'react-bootstrap';
import {
  FormControl,
  Button,
} from '../component/form/FormControls.jsx';
import { connect } from 'react-redux';
import store/* , { fallThrough, fallThroughClear, fallThroughInitial,
  fallThroughReturn, fallThroughPop }*/ from '../store/store';
import { push, replace, goBack as reactGoBack } from 'react-router-redux';
import getFormData from 'get-form-data';
// import { BreadcrumbsItem } from 'react-breadcrumbs-dynamic';
import './util.css';
export const dateTimePickerFormat = 'DD MMM YYYY';
export const timePickerFormat = 'HH:mm';
export const DictonaryCacheTime = 600000;

export const MFA_CODES = [ "MFA_CODE_REQUIRED", "WRONG_MFA_CODE" ];

export const dateMonths = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
]
import { formatNumber } from '../component/blogic/deals/elements/BaseElement';
import { Header } from '@/component/header/Header.jsx';
import momentLocalizer from 'react-widgets-moment';
import moment from 'moment';
import { reportResetConfirm } from '@/store/allaround.store';
import { getCurrencyValue } from '../component/blogic/deals/expenses/ExpensesUtils';
import { formatQuantityRangeNatural } from '@/component/blogic/reports/PositionBook';
import { Currency } from '@/consts/currency';
import { loadStates } from '../component/currencies/currencies.store';
moment.locale('en');
momentLocalizer();

const currencyFormat = '0,0';
const quantityFormat = '0,0.[000]a';

export const ifExists = (obj) => ({
  map: (f) => ({
    orElse: (val) => (obj == null ? val : f(obj)),
  }),
});

export const fixDate = (date) =>
  new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(),
    date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));

export const reportFormatter = (value) => {
  if (Math.abs(value) < 1000000) {
    return formatNumber(value, currencyFormat);
  }
  return `${formatNumber(value, quantityFormat)}`.toUpperCase();
};

export const reportFormatter2 = (value) => {
  return `${formatNumber(value, '0,0.[00]a')}`.toUpperCase();
};

export const millionFormatter = (value) => {
  const millions = (value / 1000000).toFixed(2);
  return millions + 'M'
};

export const dateToUTC = (date) => {
  if (date) {
    const newDate = new Date(date);
    return new Date(Date.UTC(newDate.getFullYear(), newDate.getMonth(), 1));
  }
  return date;
};

export const getFromTab = (from = 'fromTab') => {
  const locationQuery = store.getState()
    .getIn(['routing', 'locationBeforeTransitions', 'query'], new Map());
  if (locationQuery && locationQuery.get(from)) {
    return locationQuery.get(from);
  }
  return '';
};

export const isAvoidReportReset = (firstCallReset = true) => {
  const value = store.getState().getIn(['allaround', 'avoidReportReset']);
  if (firstCallReset) {
    reportResetConfirm(store.dispatch);
  }
  return value;
};

// eslint-disable-next-line
export const addFromTab = () => getFromTab() ? `?fromTab=${getFromTab()}` : '';

/* eslint-disable */
export function locationFallThrough(name, payload, emulationKey, func) {
  if (func) {
    window.__fallThroughFunc = func;
  }
  // fallThrough && fallThrough(store.dispatch, name, payload, emulationKey);
}

export function locationFallReturn(pointIdx) {
  const f = window.__fallThroughFunc;
  if (f) {
    f.call();
  }
  window.__fallThroughFunc = null;
 // fallThroughReturn(store.dispatch, pointIdx);
}

export function locationFallThroughClear(emulationKey = null) {
  window.__fallThroughFunc = null;
 // fallThroughClear(store.dispatch, emulationKey);
}

export function locationFallThroughPop() {
  window.__fallThroughFunc = null;
 // fallThroughPop(store.dispatch);
}

export function locationFallThroughInitial(name, payload) {
  window.__fallThroughFunc = null;
//  fallThroughInitial(store.dispatch, name, payload);
}
/* eslint-enable */

export function navTo(route, resetFallThrough = false) {
  if (resetFallThrough) {
    // locationFallThroughClear();
  }
  store.dispatch(push(route));
}

export function replaceNavTo(route) {
  store.dispatch(replace(route));
}

export function goBack(currentRoute) {
  // locationFallThroughPop();
  const entryPointKey = store.getState().getIn(['allaround', 'entryPointKey']);
  if (entryPointKey && entryPointKey != history.state.key) {
    store.dispatch(reactGoBack());
  } else {
    const parsedCurrentRoute = currentRoute.match('^(.*!?)(/[0-9]*)$');
    store.dispatch(push(parsedCurrentRoute ? parsedCurrentRoute[1] : '/'));
  }
}

class UrlWrappedButtonClass extends React.Component {
  constructor() {
    super();
    this.click = this.click.bind(this);
  }

  getClassName = () => {
    const cursorClass = this.props.url ? 'cursor-pointer' : '';
    const disabled = this.props.saving ? 'disabled-during-save' : '';
    return `${this.props.className || ''} ${cursorClass} ${disabled}`;
  }

  click(e) {
    if (this.props.saving) {
      return;
    }
    if (this.props.url || this.props.onClick) {
      e.stopPropagation();
    }
    if (this.props.url) {
      if (!this.props.onClick || (this.props.onClick && this.props.onClick(e))) {
        store.dispatch(push(this.props.url));
      }
    }
  }

  render() {
    return (<Button
      className={this.getClassName()}
      disabled={this.props.saving} onClick={this.click} id={this.props.id}
    >
      {this.props.children}
    </Button>);
  }
}
UrlWrappedButtonClass.propTypes = {
  url: React.PropTypes.string,
  children: React.PropTypes.oneOfType([
    React.PropTypes.string,
    React.PropTypes.object,
    React.PropTypes.array,
  ]),
  id: React.PropTypes.string,
  onClick: React.PropTypes.func,
  name: React.PropTypes.string,
  saving: React.PropTypes.bool,
  className: React.PropTypes.string,
};

const urlButtonMapStateToProps = (state) =>
  ({ saving: state.getIn(['allaround', 'saving'], false) });

export const UrlWrappedButton = connect(urlButtonMapStateToProps)(UrlWrappedButtonClass);

class UrlWrappedLinkClass extends UrlWrappedButtonClass {
  render() {
    return (<a
      style={this.props.style}
      className={`${this.getClassName()} link`}
      onClick={this.click} id={this.props.id} title={this.props.title}
    >{this.props.children}</a>);
  }
}
export const UrlWrappedLink = connect(urlButtonMapStateToProps)(UrlWrappedLinkClass);

class UrlWrappedRowClass extends UrlWrappedButtonClass {
  render() {
    return (<Row
      {...this.props}
      onClick={this.click}
      className={this.getClassName()}
    >
      {this.props.children}
    </Row>);
  }
}
export const UrlWrappedRow = connect(urlButtonMapStateToProps)(UrlWrappedRowClass);

class UrlWrappedColClass extends UrlWrappedButtonClass {
  render() {
    return (<Col
      {...this.props}
      onClick={this.click}
      className={this.getClassName()}
    >
      {this.props.children}
    </Col>);
  }
}
export const UrlWrappedCol = connect(urlButtonMapStateToProps)(UrlWrappedColClass);

class UrlSimpleWrappedLinkClass extends UrlWrappedButtonClass {
  render() {
    return (<a
      onClick={this.click} id={this.props.id}
      style={this.props.style}
      disabled={this.props.saving}
      className={this.getClassName()}
    >
      {this.props.children}</a>);
  }
}
export const UrlSimpleWrappedLink = connect(urlButtonMapStateToProps)(UrlSimpleWrappedLinkClass);

class UrlSimpleWrappedDivClass extends UrlWrappedButtonClass {
  render() {
    return (<div
      onClick={this.click} id={this.props.id}
      style={this.props.style}
      className={this.getClassName()}
    >
      {this.props.children}</div>);
  }
}
export const UrlSimpleWrappedDiv = connect(urlButtonMapStateToProps)(UrlSimpleWrappedDivClass);


class UrlSimpleWrappedSpanClass extends UrlWrappedButtonClass {
  render() {
    return (<span
      className={this.getClassName()}
      onClick={this.click} id={this.props.id}
      style={this.props.style}
    >
      {this.props.children}</span>);
  }
}
export const UrlSimpleWrappedSpan = connect(urlButtonMapStateToProps)(UrlSimpleWrappedSpanClass);


export const LinkLikeButton = (props) => {
  const style = { padding: 0,
    lineHeight: 1,
    fontSize: '13px',
    float: 'left',
    marginRight: 5,
    ...props.buttonStyle };
  return props.onClick ?
    <Button
      onClick={props.onClick} bsStyle="link" className="link" style={style}
      id={props.id}
    >
      {props.children}
    </Button> :
    <Button
      bsStyle="link" className="link" style={style} id={props.id}
    >
      {props.children}
    </Button>;
};
LinkLikeButton.propTypes = {
  children: React.PropTypes.object,
  onClick: React.PropTypes.func,
  buttonStyle: React.PropTypes.func,
  id: React.PropTypes.string,
};
export function appendCheckBoxesFromElementName(formName, FormData) {
  $.each($(`#${formName} input:checkbox,input:radio`), function mergeCheckbox(idx, obj) {
    $.extend(FormData, { [obj.name]: this.checked });
  });
}

export function createFormDataFromElementName(elementName) {
  // ie workaround
  const formFromFieldSet = $(`#${elementName}`).clone().children()
    .unwrap()
    .wrapAll('<form/>')
    .parent()[0];
  const formData = getFormData(formFromFieldSet);
  appendCheckBoxesFromElementName(elementName, formData);
  return formData;
}

export function appendCheckBoxesFromElement(form, FormData) {
  $.each($(form).find('input:checkbox'), function mergeCheckbox(idx, obj) {
    $.extend(FormData, { [obj.name]: this.checked });
  });
}

export function createFormDataFromElement(element) {
  // ie workaround
  const formFromFieldSet = $(element).clone().children()
    .unwrap()
    .wrapAll('<form/>')
    .parent()[0];
  const formData = getFormData(formFromFieldSet);
  appendCheckBoxesFromElement(element, formData);
  return formData;
}

export function createFormData(formName) {
  const domElement = document.querySelector(`#${formName}`);
  if (!domElement) {
    return null;
  }
  const formData = getFormData(domElement);
  appendCheckBoxesFromElementName(formName, formData);
  return formData;
}

export function getFieldData(formName, fieldName) {
  const form = document.querySelector(`#${formName}`);
  return getFormData.getNamedFormElementData(form, fieldName);
}

export function getArrayFieldData(formName, fieldName) {
  const toArray = function toArray(value) {
    if (value === null) {
      return null;
    }
    return (Array.isArray(value) ? value : Array.of(value));
  };
  const form = document.querySelector(`#${formName}`);
  return toArray(getFormData.getNamedFormElementData(form, fieldName));
}

export const TableOptions = {
  sizePerPage: 100,
  sizePerPageList: [100, 150, 300],
};

export const CenterBox = args =>
  <div
    style={{ ...args.style,
      display: 'table',
      position: 'absolute',
      height: '100%',
      width: '100%' }}
  >
    <div style={{ display: 'table-cell', verticalAlign: 'middle' }}>
      <div
        style={{ marginLeft: 'auto',
          marginRight: 'auto',
          width: args.width,
          height: args.height,
          maxWidth: '100vw' }}
      >
        {args.children}
      </div>
    </div>
  </div>;

/*
const BreadcrumbItems = () => {
  if (store.getState) {
    const fallsThrough = store.getState().getIn(['routing', 'falls'], new List());
    const items = fallsThrough.map((item, idx) =>
      <BreadcrumbsItem
        to={`/${idx}`}
        idx={idx}
        onClickFunc={() => {
          locationFallReturn(idx);
          navTo(item.get('payload'));
        }}
      >
        {item.get('name')}
      </BreadcrumbsItem>,
    );
    return (
      <div>{items}</div>
    );
  }
  return <div />;
};*/

// eslint-disable-next-line
class MainComponentBoxClass extends React.Component {

  shouldComponentUpdate(props) {
    return (!props.isLoading);
  }
  render() {
    const className = this.props.useMobileVersion ? `${this.props.className || ''} use-mobile` :
      `${this.props.className || ''} dont-use-mobile`;
    return (
      <div className={className} style={this.props.style || {}}>
        <Header secondNavBar={this.props.secondNavBar} />
        <Grid
          className={this.props.wide ? 'container-wide' : ''}
          style={{ top: this.props.nomargin ? -21 : 0, position: 'relative' }}
        >
          <Row style={this.props.childrenStyle}>
            <Col xs={12} md={12} lg={12} style={this.props.colStyle}>
              {this.props.children}
            </Col>
          </Row>
        </Grid>
      </div>);
  }
}
MainComponentBoxClass.propTypes = {
  children: React.PropTypes.oneOfType([React.PropTypes.object, React.PropTypes.array]),
  colStyle: React.PropTypes.object,
  nomargin: React.PropTypes.bool,
  isLoading: React.PropTypes.bool,
  secondNavBar: React.PropTypes.object,
  className: React.PropTypes.string,
  style: React.PropTypes.object,
  useMobileVersion: React.PropTypes.bool,
  wide: React.PropTypes.bool,
  withBreadcrumb: React.PropTypes.bool,
  childrenStyle: React.PropTypes.object,
};
export const MainComponentBox = connect(state => ({
  isLoading: state.getIn(['storeStatus', 'isLoading'], false),
  useMobileVersion: state.getIn(['allaround', 'useMobileVersion'], true),
}))(MainComponentBoxClass);

const errorProps = state => ({
  error: state.get('error'),
});

export const FormGroupWValidation = connect(errorProps)((props) => {
  const { id } = props;
  const errorForMe = props.error.get(id);
  // eslint-disable-next-line
  const {dispatch,error,...newProps} = props;
  return (<div><FormGroup {...newProps} validationState={errorForMe ? 'error' : null}>
    {props.children}
    {errorForMe ? <HelpBlock>{errorForMe}</HelpBlock> : ''}
    <FormControl.Feedback />
  </FormGroup>
  </div>);
});

export function checkIfCacheRefreshNeeded(refName, cacheTime = DictonaryCacheTime) {
  const status = store.getState().getIn(['storeStatus', refName]);
  if (status && status.status == 'loaded' && cacheTime === 'INF') {
    return false;
  }
  if (!status || !status.status ||
     (status.status == 'loaded' && Date.now() - status.date > cacheTime)) {
    return true;
  }
  return false;
}

let loadingQueued = {};

export function clearQueue() {
  setTimeout(() => { loadingQueued = {}; }, 0);
}

async function loadAsync(loadFunc, refName, refPath) {
  if (loadFunc(store.dispatch, refName, refPath)) {
    loadingQueued[refName] = false;
  }
}
export function checkStoreStatus(refName, refPath, loadFunc,
  cacheTime = DictonaryCacheTime) {
  if (loadingQueued[refName]) {
    return false;
  }
  const needsLoading = checkIfCacheRefreshNeeded(refName, cacheTime);
  if (needsLoading) {
    loadingQueued[refName] = true;
    loadAsync(loadFunc, refName, refPath);
    return false;
  } else if (store.getState().getIn(['storeStatus', refName]).status == 'loading') {
    return false;
  }
  loadingQueued[refName] = false;
  return true;
}

function hexDec(input) {
  const hex = (`${input}`).replace(/[^a-f0-9]/gi, '');
  return parseInt(hex, 16);
}

function getBrightness(color) {
  const hex = color.replace('#', '');
  const red = hexDec(hex.substr(0, 2));
  const green = hexDec(hex.substr(2, 2));
  const blue = hexDec(hex.substr(4, 2));
  return ((red * 0.33) + (green * 0.5) + (blue * 0.16));
}

export function getFontColorFromBackground(hexColor) {
  if (getBrightness(hexColor) < 120) {
    return 'white';
  } return 'black';
}

export function getRegNumberText(data, prefix, contractorName, regNumberProp, defaultValue) {
  if (data.get(regNumberProp)) {
    return `${prefix}-${contractorName}${data.get(regNumberProp)}`;
  }
  return defaultValue;
}

function composeRegNumber(data, regNumberProp, defaultValue) {
  if (data.get(regNumberProp)) {
    return (<span>
      {data.get(regNumberProp)}
    </span>);
  } return <span>{defaultValue}</span>;
}

export function composeSaleRegNumber(data, regNumberProp, defaultValue) {
  return composeRegNumber(data, regNumberProp, defaultValue);
}

export function composePurchaseRegNumber(data, regNumberProp, defaultValue) {
  return composeRegNumber(data, regNumberProp, defaultValue);
}

export function composeAbbrev(name) {
  return !name || name == ''
    ? ''
    : (`${name.substr(0,
      name.length >= 3
        ? 3
        : name.length).toUpperCase()}-`);
}

export function formatThousandCommas(num, delimiter) {
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, delimiter);
}

// RGBA to HEX
export function rgba2hex(rgb) {
  const val = rgb.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i);
  const calc = function calc(num) {
    return (`0${parseInt(val[num], 10).toString(16)}`).slice(-2);
  };
  return (val && val.length === 4)
    ? `#${calc(1)}${calc(2)}${calc(3)}`
    : '';
}

// Color (actually it's used for painting of CompositeProduct)
export function paintColor(id) {
  const red = 200 + (id * 4) % 50;
  const green = 200 + (id * 8) % 50;
  const blue = 200 + (id * 16) % 50;
  return rgba2hex(`rgba(${red}, ${green}, ${blue})`);
}

export function paintColorAcid(objectId) {
  const id = objectId || 255;
  const h = id * 33 % 255;
  const s = 57;
  const l = 77 + (id % 5);
  return `hsla(${h}, ${s}%, ${l}%,1)`;
}


export function paintColorSaleBlue(objectId) {
  const id = objectId || 255;
  const l = 50 + (id % 8) * 5;
  return `hsla(188, 57%, ${l}%,1)`;
}
export function paintColorPurchaseBlue(objectId) {
  const id = objectId || 255;
  const l = 50 + (id % 8) * 5;
  return `hsla(234, 57%, ${l}%,1)`;
}

export const getColor = (product) => {
  if (product) {
    let color = product
      .get('color');

    if (!color || color == '#FFFFFF') {
      color = product
        ? paintColor(product.get('id'))
        : 'inherited';
    }
    return color;
  }
  return 'inherited';
};

export const getDeliveryTermCs = () => Set.of('CFR', 'CIF', 'CPT', 'CIP');

export const getDeliveryTermFs = () => Set.of('FOB', 'FCA', 'FOT');

export const getDeliveryTermDs = () => Set.of('DAT', 'DAF', 'DDP', 'DAP');

export const getLoadingTermDerliveryTerms = () => Set.of('FOB', 'CFR', 'CIF');

export const getDeliveryTermUnion = () =>
  getDeliveryTermCs().concat(getDeliveryTermFs()).concat(getDeliveryTermDs());

// Хак для фикса бага в IE - поля ввода не доступны,
// пока не изменится размер браузера/корневого элемента
export function dirtyIEHack() {
  const ua = window.navigator.userAgent;
  if (ua.indexOf('MSIE') > -1 || ua.indexOf('Trident') > -1) {
    setTimeout(() => {
      $('body').css('width', $(document).width() - 1);
      setTimeout(() => $('body').css('width', '', 0));
    }, 0);
  }
}

export const usdDefaultCurrencyRates = (rates = new List()) => {
  let fixedRates = Array.isArray(rates) ? fromJS(rates) : rates;
  fixedRates = fixedRates ? fixedRates : new List();    //eslint-disable-line
  const usdRates = store.getState().getIn(['data', 'currencies', 'USD', 'rates'], new List())
    .map(elem => elem.set('value', elem.get('currency')));
  if (!fixedRates.size) {
    return usdRates.size ? usdRates : null;
  }
  // если в сохраненных значениях не содержится названия валюты
  if (fixedRates.find(r => !r.get('value'))) {
    return usdRates;
  }
  return usdRates.map(usdr => {
    const fr = fixedRates.find(r => usdr.get('value') == r.get('value'), this, usdr);
    if (fr.get('rate')) {
      return fr;
    }
    return usdr;
  });
};

export const productGroups = ['Urea', 'A/N', 'A/S', 'UAN', 'Phosphates', 'Potash', 'NPKs',
  'AGRI', 'Sulfur', 'Solubles', 'Other'];

export const productNameFromLowerCase = (lcName) => productGroups.find(e =>
  e.toLowerCase() == (lcName || '').toLowerCase());

export const creationTimeTooltip = (data, children) => {
  const creationTime = data.get('creationTime');
  if (creationTime) {
    return (
      <OverlayTrigger
        placement="top"
        overlay={<Tooltip>{moment(`${creationTime.get('dayOfMonth')}
      .${creationTime.get('monthValue')}.${creationTime.get('year')}`, 'DD.MM.YYYY')
          .format('DD MMM YYYY')}</Tooltip>}
      >
        <div>
          {children}
        </div>
      </OverlayTrigger>
    );
  }
  return children;
};

export const productNameResolver = (cp) => {
  const product = store.getState().getIn(['references', 'complex', 'product'])
    .find(p => p.get('id') === cp.product, this, new Map());
  let productName = product.get('name');
  if (cp.productType) {
    const productType = product.get('productTypes')
      .find(pt => pt.get('id') === cp.productType, this, new Map());
    if (productType.get('name') !== 'DEFAULTPRODUCTTTYPE') {
      productName += ` / ${productType.get('name')}`;
    }
  }
  return productName;
};

export const originNameResolver = (id) =>
  store.getState().getIn(['references', 'simple', 'origin'])
    .find(p => p.get('id') === id, this, new Map())
    .get('name', '');

export const userSelectNameResolver = (id) => store.getState().getIn(['data', 'users_select'])
  .find(p => p.get('id') === id, this, new Map())
  .get('fullname', '');

export const userHasLock = (dealType, dealId) => {
  const currentUser = Number(store.getState().getIn(['session', 'id']));
  const dealLockList = store.getState().getIn(['data', 'locks', dealType]);
  const dealLock = dealLockList.get(String(dealId)) || dealLockList.get(dealId, new Map());
  return dealLock.get('ownerId') === currentUser;
};

export const avg = (...arg) => arg.reduce((sum, v) => sum + parseFloat(v), 0) / arg.length;

export const avgPriceQuantity = (data, unlinkedMinFunc, unlinkedMaxFunc, overridenPriceFunc,
  dealTypeFunc, compositeProductFunc, calcM2MPLFunc) => {
  const grouppedProducts = {};
  data.forEach(v => {
    const cp = compositeProductFunc(v);
    const overridenPrice = overridenPriceFunc(v);
    let m2mPL = 0;
    let fobNetback = 0;
    if (calcM2MPLFunc) {
      cp.externalM2M = v.get('externalM2M');
      cp.fobNetBackOriginal = v.get('fobNetBackOriginal');
      cp.dealType = v.get('dealType');
      cp.mtsNatural = formatQuantityRangeNatural(v.toJS());
      if (overridenPrice || overridenPrice === 0) {
        cp.priceValue = overridenPrice;
        cp.overridenPrice = overridenPrice;
        cp.priceCurrency = Currency.DOLLAR;
      }
      m2mPL = calcM2MPLFunc(cp);
      fobNetback = cp.fobNetBack || cp.fobNetBackOriginal;
    }
    const hasFormula = cp.fixedPrice === false;
    const key = `${cp.productType}_${dealTypeFunc(v)}_${hasFormula}`;
    const currentGroup = grouppedProducts[key] || {};
    const avgQ = avg(unlinkedMinFunc(v), unlinkedMaxFunc(v));
    const productPrice = hasFormula ? 0 : getCurrencyValue(fromJS(cp));

    grouppedProducts[key] = {
      name: currentGroup.name || productNameResolver(cp),
      dealType: dealTypeFunc(v),
      style: currentGroup.style ||
        (dealTypeFunc(v) === 'purchase' ? 'purchase-color' : 'sale-color'),
      totalPrice: hasFormula ? 'N/A'
        : (currentGroup.totalPrice || 0) + (overridenPrice || productPrice) * avgQ,
      avgQ: (currentGroup.avgQ || 0) + avgQ,
      m2mPL: (currentGroup.m2mPL || 0) + m2mPL,
      fobNetback: (currentGroup.fobNetback || 0) + fobNetback,
      groupSize: (currentGroup.groupSize || 0) + 1,
      hasFormula: hasFormula
    };
  });
  return grouppedProducts;
};

export const formatPositionBookGroupName = (groupData) => {
  let suffix = "";
  if (groupData.hasFormula) {
    suffix = " with formula";
  }
  return groupData.name + suffix;
}

export const formatGroupedProductAvgQ = (groupData) => {
  if (groupData.avgQ) {
    if (groupData.hasFormula) {
      return groupData.avgQ;
    }
    return Math.round(groupData.totalPrice / groupData.avgQ);
  }
  return 0;
}


/* eslint-disable */
export const lightenDarkenBlendColor = (p /* light or blend level darer < 0 lighter > 0*/, c0, c1, l) => {
  let r,
    g,
    b,
    P,
    f,
    t,
    h,
    i = parseInt,
    m = Math.round,
    a = typeof(c1) == 'string';
  if (typeof(p) != 'number' || p < -1 || p > 1 || typeof(c0) != 'string'
    || (c0[0] != 'r' && c0[0] != '#') || (c1 && !a)) return null;
  const pSBCr = (d) => {
    let n = d.length,
      x = {};
    if (n > 9) {
      [r, g, b, a] = d = d.split(','), n = d.length;
      if (n < 3 || n > 4) return null;
      x.r = i(r[3] == 'a' ? r.slice(5) : r.slice(4)), x.g = i(g), x.b = i(b), x.a = a ? parseFloat(a) : -1;
    } else {
      if (n == 8 || n == 6 || n < 4) return null;
      if (n < 6)d = `#${d[1]}${d[1]}${d[2]}${d[2]}${d[3]}${d[3]}${n > 4 ? d[4] + d[4] : ''}`;
      d = i(d.slice(1), 16);
      if (n == 9 || n == 5) {
        x.r = d >> 24 & 255, x.g = d >> 16 & 255, x.b = d >> 8 & 255,
        x.a = m((d & 255) / 0.255) / 1000;
      } else x.r = d >> 16, x.g = d >> 8 & 255, x.b = d & 255, x.a = -1;
    } return x;
  };

  h = c0.length > 9, h = a ? c1.length > 9 ? true : c1 == 'c' ? !h : false : h, f = pSBCr(c0),
  P = p < 0, t = c1 && c1 != 'c' ? pSBCr(c1) : P ? { r: 0, g: 0, b: 0, a: -1 }
    : { r: 255, g: 255, b: 255, a: -1 }, p = P ? p * -1 : p, P = 1 - p;
  if (!f || !t) return null;
  if (l)r = m(P * f.r + p * t.r), g = m(P * f.g + p * t.g), b = m(P * f.b + p * t.b);
  else {
    r = m((P * f.r ** 2 + p * t.r ** 2) ** 0.5),
    g = m((P * f.g ** 2 + p * t.g ** 2) ** 0.5), b = m((P * f.b ** 2 + p * t.b ** 2) ** 0.5);
  }
  a = f.a, t = t.a, f = a >= 0 || t >= 0, a = f ? a < 0 ? t : t < 0 ? a : a * P + t * p : 0;
  if (h) return `rgb${f ? 'a(' : '('}${r},${g},${b}${f ? `,${m(a * 1000) / 1000}` : ''})`;
  return `#${(4294967296 + r * 16777216 +
    g * 65536 + b * 256 + (f ? m(a * 255) : 0)).toString(16).slice(1, f ? undefined : -2)}`;
};

export function getCurrencyStatesWrapper() {
  const states = store.getState().getIn(['data', 'currencies', 'states']);
  if (!states || !states.size) {
    loadStates(store.dispatch);
  }
}

export const formatCurrency = (currencyString) => {
  return store.getState().getIn(['data', 'currencies', 'states'], new List())
    .find(cs => cs.get('currency') === currencyString, this, new Map()).get('sign', '$');
};
